import CodeIcon from "@mui/icons-material/Code";
import {
  InputBase,
  InputLabel,
  RadioGroup,
  Select,
  Slider,
  SliderThumb,
  styled,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const CustomLabel = styled(InputLabel)(() => ({
  display: "block",
  position: "unset",
  color: "#000",
  // fontSize: 16,
  transform: "none",
  // fontWeight: 400,
  "& > span": {
    color: '#000',
  },
  "&.MuiInputLabel-root.Mui-focused": {
    color: '#000'
  },
  "&.MuiInputLabel-root.Mui-error": {
    color: '#000'
  }
}));

const CustomInput = styled(InputBase)(({ theme }) => ({
  // maxWidth: "300px",
  maxWidth: "300px",
  width: "100%",
  "label + &": {
    marginTop: theme.spacing(1),
  },
  color: "#000",
  "& .MuiInputBase-input": {
    borderRadius: 8,
    position: "relative",
    backgroundColor: "#ffffff",
    fontSize: 14,
    fontFamily:"Cerebri sans",
    width: "100%",
    padding: `${theme.spacing(1.25)} ${theme.spacing(1.5)}`,
    transition: "border-color 0.3s",
    border: "1px solid #D1D1D1",
    "&:focus": {
      border: "1px solid #000",
    },
  },
  "&.Mui-error .MuiInputBase-input": {
    borderColor: "#D1D1D1",
  },
}));

const CustomSelect = styled(Select)(({ theme }) => ({
  color: "#000",
  "label + &": {
    marginTop: theme.spacing(1),
  },
  boxShadow: 'none', 
  
  "& .MuiInputBase-input": {
    borderRadius: 16,
    position: "relative",
    backgroundColor: "#ffffff",
    fontSize: 16,
    width: "100%",
    padding: `11px 16px`,
    height: "44px",
    transition: "border-color 0.3s",
  },

  ".MuiSelect-select:focus": {
    backgroundColor: 'white',
    borderRadius: 16,
  },

  // "input:not(:placeholder-shown) + .css-1e88mfs-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-1e88mfs-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-1e88mfs-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
  //   backgroundColor: 'green'
  // },
  "& .MuiSelect-icon": {
    right: '16px',
    display: "flex"
  },
  "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: '1px solid #000',
  },

  MenuProps: {
    PaperProps: {
      sx: {
        bgcolor: 'blue',
        '& .MuiMenuItem-root': {
          padding: 2,
        },
      },
    },
  },
  "&.Mui-error .MuiInputBase-input": {
    borderColor: theme.palette.error.main,
  },
}));

const CustomRadioGroup = styled(RadioGroup)(() => ({
 "label > span" :  {color: "#000" }
}));

const CustomSlider = styled(Slider)(() => ({
  color: "#ffffff",
  height: 5,
  marginTop: "36px",
  padding: "15px 0",
  borderRadius: 16,
  "& .MuiSlider-thumb": {
    height: 40,
    width: 40,
    border: "3px solid #F3F3F3",
    "&:focus, &:hover, &.Mui-active": {},
    "& .MuiSvgIcon-root": {
      fill: "#000000",
    },
  },
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-rail": {
    opacity: "1",
  },
  "& .MuiSlider-mark": {
    display: "none",
  },
  "& .MuiSlider-markLabel": {
    color: "currentColor",
    marginTop: 5,
  },
  "& .MuiSlider-valueLabel": {
    backgroundColor: "currentColor",
  },
  "& .MuiSlider-valueLabel span": {
    color: "#000000",
  },
}));

const CustomSliderThumb = (props) => {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <CodeIcon sx={{ width: 24 }} />
    </SliderThumb>
  );
};

CustomSliderThumb.propTypes = {
  children: PropTypes.node,
};

const PlaceHolderInputField = styled(TextField)(() => ({
  maxWidth: "300px",
  width: "100%",

  "& .MuiOutlinedInput-root": {
    borderRadius: 6,
  },

    "& .MuiInputBase-input": {
    borderRadius: 6,
    position: "relative",
    backgroundColor: "#FFF",
    width: "100%",
    padding: "11px 16px",
    transition: "border-color 0.3s",
    boxSizing: "border-box",
    height: "44px",
    fontSize: 14,
    fontFamily: "Cerebri sans !important",
  },

  "input": {
    "&::placeholder": {
      fontFamily: "Cerebri sans !important",
      fontSize: "14px !important",
      letterSpacing :"0",
      color: "#000 !important",  // or any other color you want
      opacity: 1,  // Ensures full opacity
      
    },
  },

  /* label */
  "& .MuiInputLabel-formControl": {
    top: "22px",
    left: "16px",
    fontSize: "14px",
    transform: "translateY(-50%)",
    transition: "all 0.2s ease",
  },

  /* shrunk label (focus OR filled OR error) */
  "& .MuiInputLabel-shrink": {
    fontSize: "10px",
    color: '#000 !important',
    // lineHeight: "1",
    transform: "translate(-3px, -29px)",
  },
 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #000 !important",
  },
  /* notch follows shrink automatically */
  "& .MuiOutlinedInput-notchedOutline legend > span": {
    padding: "0 4px",
    fontSize: "10px",
    // lineHeight: "1",
    whiteSpace: "nowrap",
  },
}));

export { CustomLabel, CustomInput, CustomSlider, CustomSelect, PlaceHolderInputField, CustomRadioGroup };
